import React from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "../Theme";

import styles from "./HintBox.scss";
import HintBoxHeading from "./HintBoxHeading";
import HintBoxText from "./HintBoxText";
import HintBoxLink from "./HintBoxLink";

export class HintBox extends React.Component {
  static propTypes = {
    variants: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  };

  static defaultProps = {
    variants: "",
  };

  static displayName = "HintBox";

  static Variant = {
    alert: styles.alert,
  };

  static contextType = ThemeContext;

  static Text = HintBoxText;

  static Heading = HintBoxHeading;

  static Link = HintBoxLink;

  render() {
    const { children } = this.props;
    let { variants } = this.props;

    if (!variants) {
      variants = styles.hintBox;
    }

    if (typeof variants !== "string") {
      variants = variants.join(" ");
    }

    if (this.context) {
      variants += ` ${styles[this.context]}`;
    }

    return <div className={variants}>{children}</div>;
  }
}

export default HintBox;
